import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import designCategory from "@/store/modules/designCategory";
export default {
  data: function data() {
    return {
      scale: this.$store.state.designCategory.scale
    };
  },
  mounted: function mounted() {
    document.getElementById('scaleInput').addEventListener('keypress', function (e) {
      // if (e.charCode < 96 || e.charCode > 105) {
      //
      //   return e.preventDefault()
      // }
      if (!/\d/.test(parseInt(e.key))) {
        return e.preventDefault();
      }
    });
  },
  watch: {
    scaleNum: function scaleNum() {
      this.scale = this.$store.state.designCategory.scale;
    }
  },
  computed: {
    scaleNum: function scaleNum() {
      return this.$store.state.designCategory.scale;
    } // scale: {
    //   get(){
    //     return this.$store.state.design.scale
    //   },
    //   set(val){
    //     this.$store.commit('design/set_scale', parseInt(val) || 0)
    //   }
    // }
  },
  methods: {
    handleInput: function handleInput(e) {
      var value = 0;
      if (e.target.value === '') {
        value = 0;
      } else {
        value = parseInt(e.target.value);
        if (!Number.isInteger(value)) {
          value = 0;
        }
      }
      if (value > this.$store.state.design.maxScale) {
        value = this.$store.state.design.maxScale;
      }
      if (value < 0) {
        value = 0;
      }
      this.scale = value;
      this.$store.commit('designCategory/set_scale', this.scale);
    },
    handleChange: function handleChange(e) {
      var value = 0;
      if (e.target.value === '') {
        value = 0;
      } else {
        value = parseInt(e.target.value);
        if (!Number.isInteger(value)) {
          value = 0;
        }
      }
      if (value > this.$store.state.design.maxScale) {
        value = this.$store.state.design.maxScale;
      }
      if (value < this.$store.state.design.minScale) {
        value = this.$store.state.design.minScale;
      }
      this.scale = value;
      this.$store.commit('designCategory/set_scale', this.scale || this.$store.state.design.minScale);
    }
  }
};